module.exports = __webpack_public_path__ + "static/media/check.c579b1a3.png";